
import {Col, Row} from "react-bootstrap";
import GuidePostTile from "./components/GuidePostTile.tsx";
import useTopPerformingGp from "@oldDashboard/legacyHooks/useTopPerformingGp";
import { useMemo } from 'react';
import { getFiltersDate } from "@oldDashboard/legacyUtils";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { GuidePost } from "@oldDashboard/legacyModels/guidePost.model";
import Loader from "@/components/common/loader/loader";

interface GuidePostsSectionProps  { ideas: GuidePost[], timePeriods: TimePeriods[], affiliateSelected: any, launchSelected: String, timePeriodSelected: string, searching: boolean}
const GuidePostsTop = (props: GuidePostsSectionProps) => {
    const { ideas, affiliateSelected, launchSelected,timePeriods,timePeriodSelected, searching } = props;
    const { startDate, endDate } = getFiltersDate(timePeriods,timePeriodSelected);
    const { isLoading } = useTopPerformingGp({affiliateSelected, launchSelected, timePeriodSelected,startDate, endDate, searching});
    
    return (
        <div className="position-relative">
            <>
            { isLoading && <Loader/> }
            <Row className="d-flex flex-direction-row">
                 { useMemo(() => ideas.map((guidePost) => (
                <Col xxl={3} xl={4} lg={6} md={6} sm={12}  key={Math.random()} className="d-flex flex-direction-row flex-wrap">
                    <GuidePostTile guidePost={guidePost}/>
                </Col>
            )),[ideas])}
            </Row>
            </>
        </div>
    );
};

export default GuidePostsTop;